import React from 'react';
import { Link } from 'react-router-dom';
import { FaImage } from 'react-icons/fa';
import { formatRupiah } from '../../utils/Formatter';
import './ProductCard.css';

const ProductCard = React.memo(({ barang, API_URL, onAddToCartClick }) => {
    const brandName = barang?.Merek?.nama_merek;
    const itemName = barang?.nama_barang;
    const startingPrice = barang?.startingPrice;
    
    // PERBAIKAN: Ambil URL gambar dari array `BarangImages`
    const imageUrl = barang?.BarangImages?.[0]?.imageUrl;

    const handleButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onAddToCartClick(barang);
    };

    return (
        <Link to={`/barang/customer/${barang.id}`} className="product-card-link">
            <div className="product-card">
                <div className="card-image-container">
                    {imageUrl ? (
                        <img src={`${API_URL}/${imageUrl}`} alt={itemName} className="card-image" />
                    ) : (
                        <div className="card-image-placeholder">
                            <FaImage size={30} />
                            <span>Tidak Ada Gambar</span>
                        </div>
                    )}
                </div>
                <div className="product-info">
                    <h3 className="product-name">{itemName || 'Nama Produk'}</h3>
                    <p className="product-brand">{brandName || 'Tanpa Merek'}</p>
                    <div className="price-container">
                        <span className="price-label">Mulai dari</span>
                        <p className="product-price">{formatRupiah(startingPrice)}</p>
                    </div>
                </div>
                <button onClick={handleButtonClick} className="add-to-cart-button">
                    + Keranjang
                </button>
            </div>
        </Link>
    );
});

export default ProductCard;